// src/components/PageViewTracker.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/analytics';

/**
 * W aplikacji SPA zmiana trasy nie przeładowuje strony, więc bez tego
 * analityka widzi tylko pierwsze wejście i cały lejek jest nie do policzenia.
 */
const PageViewTracker = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // krótkie opóźnienie, żeby zdążył się ustawić tytuł strony z Helmeta
    const id = setTimeout(() => trackPageView(`${pathname}${search}`), 60);
    return () => clearTimeout(id);
  }, [pathname, search]);

  return null;
};

export default PageViewTracker;
